export class FolderRole {
    id: number;
    converterType: string = null;
    roleTitle: string = null;
    roleKey: string = null;
    roleSchema: string = null;
    autoGeneratedFields: string = null;

    parse(obj: any) {
        this.id = obj.Id;
        if (obj.ConverterType != null) this.converterType = obj.ConverterType;
        if (obj.RoleTitle != null) this.roleTitle = obj.RoleTitle;
        if (obj.RoleKey != null) this.roleKey = obj.RoleKey;
        if (obj.RoleSchema != null) this.roleSchema = obj.RoleSchema;
        if (obj.AutoGeneratedFields != null) this.autoGeneratedFields = obj.AutoGeneratedFields;
    }
}
